import styled from '@emotion/styled';
import { Slider } from '@mui/material';
import { FC } from 'react';

interface AppPrettoSliderProps {
  value?: number | null;
  onChange?: (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => void;
}

const StyledSlider = styled(Slider)({
  color: '#426AB3',
  height: '10px',
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 28,
    width: 2,
    backgroundColor: '#E7DEF5',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    borderRadius: '0',
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 20,
    background: 'unset',
    padding: 0,
    width: 50,
    height: 50,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#426AB3',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&::before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});

const PrettoSlider: FC<AppPrettoSliderProps> = ({
  value,
  onChange,
  ...props
}) => {
  const safeValue = value ?? 0;

  return (
    <StyledSlider
      value={safeValue}
      onChange={onChange}
      defaultValue={0.5}
      step={0.01}
      marks
      min={0}
      max={1}
      sx={{ width: '100%' }}
      valueLabelDisplay='auto'
      {...props}
    />
  );
};

export default PrettoSlider;
